import { Navigate } from 'react-router-dom';

import { FeatureFlagName, useHasFeatureFlag } from 'hooks/users';

import DefaultLayout from '../layout/DefaultLayout';
import { AllDeveloperCards } from './AllDeveloperCards';
import Badge from 'components/common/Badge';
import { Environment } from 'util/environment';
import { useGlobalStore } from 'hooks/global/store';
import { useSyncEnvStore } from 'hooks/global/useSyncEnvStore';

const ENVIRONMENT_BADGE_COLOR: Record<Environment, 'gray' | 'orange' | 'red'> =
  {
    local: 'gray',
    test: 'gray',
    staging: 'orange',
    production: 'red',
    unknown: 'red',
  };

export const Developer = () => {
  useSyncEnvStore();
  const showDeveloperPage = useHasFeatureFlag(FeatureFlagName.DEVELOPER_PAGE);
  const envData = useGlobalStore((s) => s.envs);

  if (!showDeveloperPage) {
    return <Navigate replace to={'/'} />;
  }

  return (
    <DefaultLayout>
      <div className="min-h-full pt-6 pb-32 px-8 bg-gray-50">
        <div className="flex items-start justify-between mb-10">
          <div className="space-y-1 w-full">
            <div className="flex justify-between text-xl text-primary-d-600 font-medium mb-8">
              Developer Controls
              <div className="flex items-center px-4 gap-4 text-xs">
                You are currently connected to:
                <Badge
                  color={ENVIRONMENT_BADGE_COLOR[envData.frontendEnv]}
                  size="md"
                >
                  {`Frontend: ${envData.frontendEnv}`}
                </Badge>
                <Badge
                  color={ENVIRONMENT_BADGE_COLOR[envData.backendEnv]}
                  size="md"
                >
                  {`Backend: ${envData.backendEnv}`}
                </Badge>
                <Badge
                  color={ENVIRONMENT_BADGE_COLOR[envData.databaseEnv]}
                  size="md"
                >
                  {`Database: ${envData.databaseEnv}`}
                </Badge>
              </div>
            </div>
            <AllDeveloperCards />
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};
